export function createDialogController({dialogs=[],menuButton=null,onBeforeOpen=()=>{},onAfterClose=()=>{}}={}){
 const setMenuExpanded=dialog=>menuButton?.setAttribute('aria-expanded',dialog?.id==='menu-dialog'?'true':'false');
 const open=dialog=>{
  if(!dialog||dialog.open)return;
  onBeforeOpen(dialog);dialog.showModal();setMenuExpanded(dialog);
 };
 const close=dialog=>{
  if(!dialog||!dialog.open)return;
  dialog.close();setMenuExpanded(null);onAfterClose(dialog);
 };
 for(const dialog of dialogs){
  dialog.querySelector('.close')?.addEventListener('click',()=>close(dialog));
  dialog.addEventListener('cancel',()=>{setMenuExpanded(null);onAfterClose(dialog);});
  dialog.addEventListener('click',event=>{
   if(event.target!==dialog)return;
   const rect=dialog.getBoundingClientRect();
   if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close(dialog);
  });
 }
 return {open,close};
}
